import React from "react";
import "./crosswalkSecurity.css";
import Button from "../common/Button";

const CrosswalkSecurity = () => {
  return (
    <div className="cred-security photo-section">
      <div className="max-width">
        <div className="photo-section-child">
          <div className="photo-section-top">
            <div className="photo-section-heading">
            security first. always.
            </div>
            <div className="photo-section-subheading">
            your data stays yours.
            </div>
          </div>
          <div className="photo-section-bottom">
            <div className="photo-section-desc">
           Crosswalk uses heavy encryption and strict safety checks to keep your money and info fully protected.
            no leaks. no risks. no mistakes.
            </div>
            {/* <div>
              <Button buttonText="Become a member" />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrosswalkSecurity;
